<template>
  <div class="content">
    <base-header class="pb-6">
      <div class="row align-items-center py-4">
        <div class="col-lg-6 col-7">
          <h6 class="h2 text-white d-inline-block mb-0">Export Sheets</h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </div>
      </div>
    </base-header>
    <div class="container-fluid mt--6">
      <modal
        :show.sync="modals.showModal"
        body-classes="p-0"
        modal-classes="modal-dialog-centered modal-md"
      >
        <card
          type="secondary"
          shadow
          header-classes="bg-white pb-5"
          class="border-0"
        >
          <template>
            <form role="form">
              <div class="form-group row mb--2">
                <label class="col-md-4 col-form-label form-control-label"
                  >Type</label
                >
                <div class="col-md-8">
                  <multiselect
                    style="margin-bottom: 15px"
                    placeholder="Select collection"
                    v-model="collectionData"
                    :options="collectionOptions"
                    :close-on-select="true"
                    :clear-on-select="false"
                    :hide-selected="false"
                    :preserve-search="true"
                    :preselect-first="true"
                    id="example"
                  >
                  </multiselect>
                </div>
              </div>
              <div class="form-group row mb--2">
                <label class="col-md-4 col-form-label form-control-label"
                  >Date range</label
                >
                <div class="col-md-8">
                  <base-input addon-left-icon="ni ni-calendar-grid-58">
                    <flat-picker
                      slot-scope="{ focus, blur }"
                      @on-open="focus"
                      @on-close="blur"
                      :config="{ allowInput: true, mode: 'range' }"
                      class="form-control datepicker"
                      v-model="dates.range"
                    >
                    </flat-picker>
                  </base-input>
                </div>
              </div>

              <!-- @click="ExportData()"
                  :disabled="isLoading"
                  type="primary"
                  class="mt-3 col" -->
              <div>
                <downloadexcel
                  :fetch="fetchTodos"
                  type="primary"
                  class="text-center"
                >
                  <base-button class="mt-3 col" type="primary">
                    <i v-bind:class="sign"></i> {{ this.optionName }}
                  </base-button>
                </downloadexcel>
              </div>
            </form>
          </template>
        </card>
      </modal>

      <modal
        :show.sync="modals.showCostModal"
        body-classes="p-0"
        modal-classes="modal-dialog-centered modal-md"
      >
        <card
          type="secondary"
          shadow
          header-classes="bg-white pb-5"
          body-classes="px-lg-5 py-lg-5"
          class="border-0"
        >
          <template>
            <form role="form" class="mb--4">
              <div class="form-group row mb--2">
                <label class="col-md-6 col-form-label form-control-label"
                  >Delivery (with in Dubai)</label
                >
                <div class="col-md-6">
                  <base-input
                    placeholder="Enter delivery amount"
                    v-model="myCostObj.deliveryIn"
                  ></base-input>
                </div>
              </div>

              <div class="form-group row mb--2">
                <label class="col-md-6 col-form-label form-control-label"
                  >Delivery (outside Dubai)</label
                >
                <div class="col-md-6">
                  <base-input
                    placeholder="Enter delivery amount"
                    v-model="myCostObj.deliveryOut"
                  ></base-input>
                </div>
              </div>

              <div class="form-group row mb--2">
                <label class="col-md-6 col-form-label form-control-label"
                  >Paypal Fee (%)</label
                >
                <div class="col-md-6">
                  <base-input
                    placeholder="Enter percentage"
                    v-model="myCostObj.processingFee"
                  ></base-input>
                </div>
              </div>
              <div class="form-group row mb--2">
                <label class="col-md-6 col-form-label form-control-label"
                  >Quidash Fee</label
                >
                <div class="col-md-6">
                  <base-input
                    placeholder="Enter delivery amount "
                    v-model="myCostObj.quidashIn"
                  ></base-input>
                </div>
              </div>
              <div class="form-group row mb--2">
                <label class="col-md-6 col-form-label form-control-label"
                  >Marketplace Share (%)</label
                >
                <div class="col-md-6">
                  <base-input
                    placeholder="Enter percentage"
                    v-model="myCostObj.marketplaceShare"
                  ></base-input>
                </div>
              </div>

              <div>
                <base-button
                  :disabled="saving"
                  @click="AddCostSettings()"
                  type="primary"
                  class="col"
                >
                  <i v-bind:class="sign"></i> {{ optionName }}</base-button
                >
              </div>
            </form>
          </template>
        </card>
      </modal>

      <div>
        <card
          class="no-border-card"
          body-classes="px-0 pb-1"
          footer-classes="pb-2"
        >
          <template slot="header"> </template>
          <div>
            <div
              class="
                col-12
                d-flex
                justify-content-center justify-content-sm-between
                flex-wrap
              "
            >
              <div style="margin-bottom: 5px">
                <base-button
                  icon
                  type="primary"
                  @click="AddModal()"
                  :disabled="isLoading"
                >
                  <span class="btn-inner--icon"
                    ><i class="fas fa-download"></i
                  ></span>
                  <span class="btn-inner--text">Export Data</span>
                </base-button>

                <!-- <div >
                <base-button icon type="primary" @click="AddModal()">
                  <span class="btn-inner--icon"
                    ><i class="fas fa-edit"></i
                  ></span>
                  <span class="btn-inner--text">Add Vetter</span>
                </base-button>
              </div> -->
                <!-- Cost button -->
                <!-- <base-button
                  icon
                  type="primary"
                  @click="AddCostModal()"
                  :disabled="isLoading"
                >
                  <span class="btn-inner--icon"
                    ><i class="fas fa-edit"></i
                  ></span>
                  <span class="btn-inner--text">Update Cost</span>
                </base-button> -->

                <!-- <base-button icon type="primary" @click="AddModal()">
                  <span class="btn-inner--icon"
                    ><i class="fas fa-edit"></i
                  ></span>
                  <span class="btn-inner--text">Update Footer</span>
                </base-button> -->
              </div>

              <el-select
                hidden
                class="select-primary pagination-select"
                v-model="pagination.perPage"
                placeholder="Per page"
              >
                <el-option
                  class="select-primary pull-right"
                  v-for="item in pagination.perPageOptions"
                  :key="item"
                  :label="item"
                  :value="item"
                >
                </el-option>
              </el-select>

              <!-- <div>
                <base-input
                  v-model="searchQuery"
                  prepend-icon="fas fa-search"
                  placeholder="Search..."
                >
                </base-input>
              </div> -->
            </div>
            <!-- <el-table
              :data="queriedData"
              row-key="id"
              header-row-class-name="thead-light"
              @sort-change="sortChange"
              @selection-change="selectionChange"
            >
              <el-table-column
                v-for="column in tableColumns"
                :key="column.label"
                v-bind="column"
              >
              </el-table-column>
              <el-table-column min-width="180px" align="right" label="Options">
                <div slot-scope="{ $index, row }" class="d-flex">
                  <base-button
                    @click="editRecord($index, row)"
                    class="like btn-link"
                    type="primary"
                    size="sm"
                    icon
                  >
                    <i class="text-white far fa-edit"></i>
                  </base-button>
                </div>
              </el-table-column> 
            </el-table> -->
          </div>
          <div
            slot="footer"
            class="
              col-12
              d-flex
              justify-content-center justify-content-sm-between
              flex-wrap
            "
          >
            <!-- <div class="">
              <p class="card-category">
                Showing {{ from + 1 }} to {{ to }} of {{ total }} entries

                <span v-if="selectedRows.length">
                  &nbsp; &nbsp; {{ selectedRows.length }} rows selected
                </span>
              </p>
            </div> -->
            <!-- <base-pagination
              class="pagination-no-border"
              v-model="pagination.currentPage"
              :per-page="pagination.perPage"
              :total="total"
            >
            </base-pagination> -->
          </div>
        </card>
      </div>
    </div>
  </div>
</template>
<script>
import { Table, TableColumn, Select, Option } from "element-ui";
import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb";
import { BasePagination } from "@/components";
import clientPaginationMixin from "../Tables/PaginatedTables/clientPaginationMixin";
import swal from "sweetalert2";
import axios from "axios";
import qs from "qs";
import Vue from "vue";
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import Multiselect from "vue-multiselect";
import moment from "moment";
import downloadexcel from "vue-json-excel";
export default {
  mixins: [clientPaginationMixin],
  components: {
    BasePagination,
    Multiselect,
    RouteBreadCrumb,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    flatPicker,
    moment,
    downloadexcel,
  },
  created() {
    this.Authenticator();
    this.modals.showModal = true;
    // LoadData();
  },
  mounted() {
    this.Authenticator();
  },
  data() {
    return {
      currentDate: moment().format("YYYY-MM-DD"),
      collectionData: "",
      splitDate: {
        from: "",
        to: "",
      },
      collectionOptions: [
        "Seller",
        "Purchase",
        "Favorites",
        "Offers",
        "Users",
        "Accounting",
      ],
      dates: {
        range: this.currentDate + "to" + this.currentDate,
      },
      isLoading: false,
      myObj: {},
      myCostObj: {},
      propsToSearch: ["batch"],
      tableColumns: [
        {
          type: "selection",
        },
        {
          prop: "title",
          label: "Banner title",
          minWidth: 800,
          sortable: true,
        },
        {
          prop: "buttonText",
          label: "Button Text",
          minWidth: 800,
          sortable: true,
        },
      ],
      tableData: [],
      selectedRows: [],
      modals: {
        showModal: false,
        showCostModal: false,
      },
      json_fields: {
        SellerID: "SellerID",
        ProductID: "ProductID",
        Date: "Date",
        AskingPrice: "AskingPrice",
        ValidityPeriod: "ValidityPeriod",
        Size: "Size",
        ListingUniqueID: "ListingUniqueID",
      },
      optionName: "Export Data",
      file: "",
      name: "",
      prefixname: "",
      prefixError: false,
      nameError: false,
      sign: "fas fa-download",
      shouldAdd: true,
      saving: false,
      eIndex: 0,
    };
  },
  methods: {
    Authenticator() {
      //console.log(this.$store.state.myUser.email , this.$store.state.myUser.password );
      if (
        this.$store.state.myUser.email == null ||
        this.$store.state.myUser.password == null ||
        this.$store.state.myUser.email == "" ||
        this.$store.state.myUser.password == ""
      ) {
        console.log("Hi If");
        this.$store.state.myUser.email = "";
        this.$store.state.myUser.password = "";

        return this.$router.push("/login");
      } else if (
        this.$store.state.isVetter == null ||
        this.$store.state.isVetter
      ) {
        return this.$router.push("/login");
      }
    },
    async fetchTodos() {
      //this.isLoading =true;
      console.log(this.dates.range);
      console.log(this.collectionData);

      if (
        this.dates.range == "undefinedtoundefined" ||
        this.dates.range == "" ||
        this.collectionData == null
      ) {
        this.$notify({
          verticalAlign: "bottom",
          horizontalAlign: "center",
          message: "Please select type and date range <br />",
          type: "danger",
          icon: "fa fa-ban",
          timeout: 0,
        });
      } else {
        this.sign = "fas fa-circle-notch fa-spin";
        this.isLoading = true;
        console.log(this.collectionData);
        var splitedDate = this.dates.range.split(" ");
        this.splitDate.from = splitedDate[0];
        this.splitDate.to = splitedDate[2];
        console.log(this.splitDate);
        const response = await axios.post(
          "https://api.thrillerme.com/export/" + this.collectionData,
          this.splitDate
        );
        if (response.status == 200) {
          this.sign = "fas fa-download";
          this.isLoading = false;
          this.modals.showModal = false;
          this.$notify({
            verticalAlign: "bottom",
            horizontalAlign: "center",
            message: "Downloaded! <br />",
            type: "success",
            icon: "fa fa-check",
            timeout: this.$store.state.timeout,
          });
          return response.data;
        } else {
          this.$notify({
            verticalAlign: "bottom",
            horizontalAlign: "center",
            message: "Request Error! <br />",
            type: "danger",
            icon: "fa fa-ban",
            timeout: 0,
          });
        }
        console.log(response);
      }
    },
    ExportData() {
      this.sign = "fas fa-circle-notch fa-spin";
      this.isLoading = true;
      console.log(this.collectionData);
      var splitedDate = this.dates.range.split(" ");
      this.splitDate.from = splitedDate[0];
      this.splitDate.to = splitedDate[2];
      console.log(this.splitDate);

      var url = "https://api.thrillerme.com/export/" + this.collectionData;

      axios
        .post(url, this.splitDate)
        .then((response) => {
          if (response.data.status === "error") {
            //console.log.log("Error saving: ", response.data);
            this.$notify({
              verticalAlign: "bottom",
              horizontalAlign: "center",
              message: "Request Error! <br />",
              type: "danger",
              icon: "fa fa-ban",
              timeout: 0,
            });
          } else {
            this.sign = "fas fa-download";
            this.isLoading = false;
            this.modals.showModal = false;

            this.LoadData();
            this.$notify({
              verticalAlign: "bottom",
              horizontalAlign: "center",
              message: "Downloaded! <br />",
              type: "success",
              icon: "fa fa-check",
              timeout: this.$store.state.timeout,
            });
            console.log(response.data);

            return response.data;
          }
        })
        .catch(function (error) {
          //console.log.log(error);
          this.$notify({
            verticalAlign: "bottom",
            horizontalAlign: "center",
            message:
              "Request Error! <br />Request cannot be processed at the moment.",
            type: "danger",
            icon: "fa fa-ban",
            timeout: 0,
          });
        })
        .finally(() => {
          this.sign = "fas fa-download";
          this.saving = false;
          this.optionName = "Export Data";
        });
    },
    LoadCostData() {
      var url = "https://api.thrillerme.com/settings";
      axios
        .get(url)
        .then((response) => {
          if (response.data.status === "error") {
          } else {
            this.myCostObj = response.data.result[0];
          }
        })
        .catch(function (error) {});
    },
    Upload() {
      //console.log.log("File:", this.file);
      this.optionName = "Uploading...";
      if (this.file !== "") {
        let formData = new FormData();
        formData.append("file", this.file);
        //console.log.log(this.file);
        axios
          .post("https://uploadert.appicksolutions.com/", formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
          .then((e) => {
            //console.log.log(e.data);
            // this.file = undefined;
            var fn = e.data.myresp[0].path;
            this.myObj.imageURL = fn;
            this.updateBanner();
          });
      } else {
        this.updateBanner();
      }
    },
    AddCostSettings() {
      //Add
      var url = "https://api.thrillerme.com/settings";

      axios
        .post(url, this.myCostObj)
        .then((response) => {
          //console.log.log(response);
          if (response.data.status === "error") {
            //console.log.log("Error saving: ", response.data);
            this.$notify({
              verticalAlign: "bottom",
              horizontalAlign: "center",
              message: "Request Error! <br />" + response.data.data,
              type: "danger",
              icon: "fa fa-ban",
              timeout: 0,
            });
          } else {
            this.modals.showCostModal = false;
            this.LoadData();
            this.$notify({
              verticalAlign: "bottom",
              horizontalAlign: "center",
              message: "Saved! <br />New Setting Updated",
              type: "success",
              icon: "fa fa-check",
              timeout: this.$store.state.timeout,
            });
          }
        })
        .catch(function (error) {
          //console.log.log(error);
          this.$notify({
            verticalAlign: "bottom",
            horizontalAlign: "center",
            message:
              "Request Error! <br />Request cannot be processed at the moment.",
            type: "danger",
            icon: "fa fa-ban",
            timeout: 0,
          });
        })
        .finally(() => {
          this.sign = "fas fa-download";
          this.saving = false;
          this.optionName = "Add";
        });
    },
    updateBanner() {
      var url = this.$store.state.domain + "/banners/" + this.myObj.banner_id;

      //console.log.log("url:", url);
      //console.log.log("data:", this.myObj);
      axios
        .put(url, this.myObj)
        .then((response) => {
          //console.log.log(response);
          if (response.data.status === "error") {
            this.$notify({
              verticalAlign: "bottom",
              horizontalAlign: "center",
              message: "Request Error! <br />" + response.data.data,
              type: "danger",
              icon: "fa fa-ban",
              timeout: 0,
            });
          } else {
            this.modals.showModal = false;
            this.$notify({
              verticalAlign: "bottom",
              horizontalAlign: "center",
              message: "Saved! <br /> Banner updated.",
              type: "success",
              icon: "fa fa-check",
              timeout: this.$store.state.timeout,
            });
          }
        })
        .catch(function (error) {
          //console.log.log(error);
          this.$notify({
            verticalAlign: "bottom",
            horizontalAlign: "center",
            message:
              "Request Error! <br />Request cannot be processed at the moment.",
            type: "danger",
            icon: "fa fa-ban",
            timeout: 0,
          });
        });

      //Update Banner API
      ////console.log.log(fn);
      this.optionName = "Update Banner";
      this.modals.showModal = false;
    },
    selectFile() {
      this.file = this.$refs.file.files[0];
    },
    Validate() {
      if (this.myObj.batch.length === 0) {
        this.nameError = "Enter Batch";
      } else {
        //Save to DB

        this.sign = "fas fa-circle-notch fa-spin";
        this.saving = true;
        this.optionName = "Saving";
        if (this.myObj.id > 0) {
          //Edit
          var url =
            this.$store.state.domain +
            "/Batch/Edit?_db=" +
            this.$store.state.db +
            "&cID=" +
            this.$store.state.cID;
          axios
            .post(url, qs.stringify(this.myObj))
            .then((response) => {
              if (response.data.status === "error") {
                this.$notify({
                  verticalAlign: "bottom",
                  horizontalAlign: "center",
                  message: "Request Error! <br />" + response.data.data,
                  type: "danger",
                  icon: "fa fa-ban",
                  timeout: 0,
                });
              } else {
                this.modals.showModal = false;
                Vue.set(this.tableData, this.eIndex, response.data.data);
                this.$notify({
                  verticalAlign: "bottom",
                  horizontalAlign: "center",
                  message:
                    'Saved! <br />Batch "' + this.myObj.batch + '" updated.',
                  type: "success",
                  icon: "fa fa-check",
                  timeout: this.$store.state.timeout,
                });
              }
            })
            .catch(function (error) {
              //console.log.log(error);
              this.$notify({
                verticalAlign: "bottom",
                horizontalAlign: "center",
                message:
                  "Request Error! <br />Request cannot be processed at the moment.",
                type: "danger",
                icon: "fa fa-ban",
                timeout: 0,
              });
            })
            .finally(() => {
              this.sign = "far fa-edit";
              this.saving = false;
              this.optionName = "Edit";
            });
        } else {
          //Add
          //console.log.log("Obj: ", this.myObj);
          var url =
            this.$store.state.domain +
            "/Batch/Create?_db=" +
            this.$store.state.db +
            "&cID=" +
            this.$store.state.cID;
          axios
            .post(url, qs.stringify(this.myObj))
            .then((response) => {
              if (response.data.status === "error") {
                //console.log.log("Error", response.data);
                this.$notify({
                  verticalAlign: "bottom",
                  horizontalAlign: "center",
                  message: "Request Error! <br />" + response.data.data,
                  type: "danger",
                  icon: "fa fa-ban",
                  timeout: 0,
                });
              } else {
                this.modals.showModal = false;
                this.tableData.push(response.data.data);
                this.$notify({
                  verticalAlign: "bottom",
                  horizontalAlign: "center",
                  message:
                    'Saved! <br />Batch "' + this.myObj.batch + '" added.',
                  type: "success",
                  icon: "fa fa-check",
                  timeout: this.$store.state.timeout,
                });
              }
            })
            .catch(function (error) {
              //console.log.log(error);
              this.$notify({
                verticalAlign: "bottom",
                horizontalAlign: "center",
                message:
                  "Request Error! <br />Request cannot be processed at the moment.",
                type: "danger",
                icon: "fa fa-ban",
                timeout: 0,
              });
            })
            .finally(() => {
              this.sign = "fas fa-user-plus";
              this.saving = false;
              this.optionName = "Update Banner";
            });
        }
        this.nameError = false;
      }
    },
    GetError() {
      return this.nameError;
      return this.prefixError;
    },
    AddModal() {
      this.saving = false;
      this.shouldAdd = true;
      this.optionName = "Export Data";
      this.modals.showModal = true;
      this.dates.range = "undefinedtoundefined";
      this.sign = "fas fa-download";
    },
    AddCostModal() {
      this.LoadCostData();
      this.saving = false;
      this.shouldAdd = true;
      this.optionName = "Add";
      this.modals.showCostModal = true;
      this.sign = "fas fa-user-plus";

      // this.myObj.user_id = 0;
      // this.myObj.firstName = "";
      // this.myObj.lastName = "";
      // this.myObj.email = "";
      // this.myObj.password = "";
      // this.myObj.verification_code = null;
      // this.myObj.isAuthenticated = true;
      // this.myObj.isApproved = true;
      // this.myObj.isSuspended = false;
      // this.myObj.suspendedTill = null;
      // this.myObj.defaultSize = null;
      // this.myObj.userInfo = null;
      // this.myObj.user_role = 3;
      // this.myObj.business_name = null;
      // this.myObj.contact = null;
      // this.myObj.paypal = null;
      // this.myObj.address = null;
    },
    editRecord(index, row) {
      this.eIndex = index;
      this.saving = false;
      this.myObj.id = row.id;
      this.myObj.batch = row.batch;

      this.shouldAdd = false;
      this.optionName = "Edit";
      this.modals.showModal = true;
      this.sign = "far fa-edit";
    },
    handleDelete(index, row) {
      swal({
        title: "Are you sure?",
        text: "You want to delete batch " + row.batch + "?",
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "btn btn-success btn-fill",
        cancelButtonClass: "btn btn-danger btn-fill",
        confirmButtonText: "Yes, delete it!",
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          //Remove API
          var url =
            this.$store.state.domain +
            "/Batch/Delete?id=" +
            row.id +
            "&_db=" +
            this.$store.state.db;
          //console.log.log("Remove: " + url);
          axios
            .post(url, qs.stringify(""))
            .then((response) => {
              if (response.data.status === "error") {
                this.$notify({
                  verticalAlign: "bottom",
                  horizontalAlign: "center",
                  message: "Request Error! <br />" + response.data.data,
                  type: "danger",
                  icon: "fa fa-ban",
                  timeout: 0,
                });
              } else {
                this.$notify({
                  verticalAlign: "bottom",
                  horizontalAlign: "center",
                  message: 'Saved! <br />Batch "' + row.batch + '" removed.',
                  type: "danger",
                  icon: "fa fa-check",
                  timeout: this.$store.state.timeout,
                });

                this.deleteRow(row);
              }
            })
            .catch(function (error) {
              this.$notify({
                verticalAlign: "bottom",
                horizontalAlign: "center",
                message: "Request Error! <br />" + response.data.data,
                type: "danger",
                icon: "fa fa-ban",
                timeout: 0,
              });
            });
        }
      });
    },
    deleteRow(row) {
      let indexToDelete = this.tableData.findIndex(
        (tableRow) => tableRow.id === row.id
      );
      if (indexToDelete >= 0) {
        this.tableData.splice(indexToDelete, 1);
      }
    },
    selectionChange(selectedRows) {
      this.selectedRows = selectedRows;
    },
  },
  computed: {
    getData() {
      return this.$store.state.gridData;
    },
  },
};
</script>
<style>
.no-border-card .card-footer {
  border-top: 0;
}
</style>
